import { useState } from "react";
import axios from "axios";

export default function AddExpense() {
  const [date, setDate] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [type, setType] = useState("general");
  const [linkedId, setLinkedId] = useState(""); // purchase/invoice ID

  const submitExpense = async () => {
    try {
      await axios.post("/api/expenses", { date, description, amount, type, linkedId });
      alert("Expense Added");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-4">Add Expense</h1>
      <div className="flex flex-col gap-4 max-w-md">
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="border p-2" />
        <input type="text" placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} className="border p-2" />
        <input type="number" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} className="border p-2" />

        <select value={type} onChange={(e) => setType(e.target.value)} className="border p-2">
          <option value="general">General</option>
          <option value="purchase_invoice">Purchase Invoice</option>
          <option value="sales_invoice">Sales Invoice</option>
          <option value="monthly">All Invoices of Month</option>
        </select>

        {(type === "purchase_invoice" || type === "sales_invoice") && (
          <input type="text" placeholder="Linked Invoice ID" value={linkedId} onChange={(e) => setLinkedId(e.target.value)} className="border p-2" />
        )}

        <button onClick={submitExpense} className="bg-green-500 text-white px-4 py-2 rounded">Save Expense</button>
      </div>
    </div>
  );
}
